import httpClient from "@utils/httpClient";

export const getAllLeaves = async (page = 1, limit = 10, fyYear = null) => {
  try {
    let url = `/leaves?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getAllLeaves error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};

export const getLeaveById = async (id) => {
  try {
    const response = await httpClient.get(`/leaves/${id}`);
    
    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getLeaveById error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const approveLeave = async (id, managedBy, remarks = null) => {
  try {
    const response = await httpClient.put(`/leaves/${id}/approve`, {
      managed_by: managedBy,
      remarks
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('approveLeave error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const rejectLeave = async (id, managedBy, remarks = null) => {
  try {
    const response = await httpClient.put(`/leaves/${id}/decline`, {
      managed_by: managedBy,
      remarks
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('rejectLeave error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};


export const getPendingLeaves = async (page = 1, limit = 10, fyYear = null) => {
  try {
    let url = `/leaves/pending?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getPendingLeaves error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};

export const getUpcomingLeaves = async (page = 1, limit = 10, fyYear = null) => {
  try {
    let url = `/leaves/upcoming?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getUpcomingLeaves error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};

export const getDeclinedLeaves = async (page = 1, limit = 10, fyYear = null) => {
  try {
    let url = `/leaves/declined?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getDeclinedLeaves error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};


export const getLeaveBalancesSummary = async (page = 1, limit = 10, fyYear = null, search = null) => {
  try {
    let url = `/leaves/balances/summary?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      selectedFY: response.selectedFY,
      carryForwardPending: response.carryForwardPending,  // ✅ New flag
      error: response.error
    };
  } catch (error) {
    console.error('getLeaveBalancesSummary error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      selectedFY: null,
      carryForwardPending: false,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};

export const getAvailableFinancialYears = async () => {
  try {
    const response = await httpClient.get('/leaves/financial-years');

    return {
      success: response.success,
      data: response.data,
      currentFY: response.currentFY,
      error: response.error
    };
  } catch (error) {
    console.error('getAvailableFinancialYears error:', error);
    return {
      success: false,
      data: [],
      currentFY: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};

export const getLeaveTypes = async () => {
  try {
    const response = await httpClient.get('/leaves/types/all');

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getLeaveTypes error:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};

export const correctLeaveDates = async (id, newStartDate, newEndDate) => {
  try {
    const response = await httpClient.put(`/leaves/${id}/correct-dates`, {
      new_start_date: newStartDate,
      new_end_date: newEndDate
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('correctLeaveDates error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const getWithdrawnLeaves = async (page = 1, limit = 10, fyYear = null) => {
  try {
    let url = `/leaves/withdrawn?page=${page}&limit=${limit}`;
    if (fyYear) {
      url += `&fy_year=${fyYear}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getWithdrawnLeaves error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};

export const updateLeaveQuota = async (userId, leaveTypeId, leavesTaken, totalLeaves = null) => {
  try {
    const body = {
      user_id: userId,
      leave_type_id: leaveTypeId,
      leaves_taken: leavesTaken
    };
    if (totalLeaves !== null && totalLeaves !== undefined) {
      body.total_leaves = totalLeaves;
    }
    const response = await httpClient.put('/leaves/balances/update', body);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('updateLeaveQuota error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};